import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import { SearchBox } from 'sharedComponents/SearchBox';
import { GeneralButton } from 'sharedComponents/GeneralButton';
import { IconHelpCircle } from 'svgIcons/MotionPortalIcons';
import { MAX_INPUT_CHAR_LENGTH } from 'helpers/constants';

const HierarchyLeftPanelHeader = (props) => {

    const {
        setSearchboxFilter,
        searchboxFilter,
        isEditHierarchy,
        setIsShowHelpModal
    } = props;

    return (
        <div className='left-panel-header'>
            <div className='left-content'>
                <SearchBox
                    onChange={setSearchboxFilter}
                    value={searchboxFilter}
                    placeholder={translate('ABB.Powertrain.Frontend.assetSearchButton')}
                    maxLength={MAX_INPUT_CHAR_LENGTH}
                />
            </div>
            {isEditHierarchy &&
                <GeneralButton
                    className='hierarch-info'
                    type='normal'
                    text={translate('ABB.Powertrain.Frontend.howToEditHierarchyLabel')}
                    icon={IconHelpCircle({ width: '16px', height: '16px' })}
                    onClick={() => setIsShowHelpModal(true)}
                />
            }
        </div>
    );
};

HierarchyLeftPanelHeader.propTypes = {
    setSearchboxFilter: PropTypes.func.isRequired,
    searchboxFilter: PropTypes.string.isRequired,
    isEditHierarchy: PropTypes.bool.isRequired,
    setIsShowHelpModal: PropTypes.func.isRequired
};

export default HierarchyLeftPanelHeader;
